import { render, staticRenderFns } from "./CardGlasses.vue?vue&type=template&id=fb9c6b00&"
import script from "./CardGlasses.vue?vue&type=script&lang=js&"
export * from "./CardGlasses.vue?vue&type=script&lang=js&"
import style0 from "./CardGlasses.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports